import {baseDataService} from "@/services/baseData.service";

export const state = {
    products:[]
}
export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async list({commit}) {         

        try {
            let prod = await baseDataService.products();
            commit('setProducts', prod);
            return prod;
        } catch (error) {
            commit('load_storage');
        }
    },
    async listDBLast({state,commit}) {         

        try {
            console.log("Try get from DB")
            if(state.products && state.products.length==0){
                let prod = await baseDataService.products(); 
                commit('setProducts', prod);
                return prod;
            }
            return state.products;
        } catch (error) {
            console.error("List categories",error)
            commit('load_storage');
        }
        return state.products
    } 
}
// export const getters = {
//     Whether the user is currently logged in.
//     products(Id) {
//         let allProductsId = localStorage.getItem(Id);
//         if(allProductsId && allProductsId.length){
//             let allProducts = [];
//             JSON.parse(allProductsId).forEach(c=>{
//                 let p = localStorage.getItem(c);
//                 if(p && p!=null){
//                     allProducts.push(JSON.parse(p));
//                 }
//             });
//             commit('load_storage');
//             return allProducts;
//         } 
//     },
// }
export const mutations = {
    setProducts(state, products) {
        state.products = products;
        let allProductKeys = products.map(x=>x.idproduct);
        localStorage.setItem("productsid",JSON.stringify(allProductKeys));
        products.forEach(x => {
            localStorage.setItem(x.idproduct,JSON.stringify(x));
        });
    },
    load_storage(state){
        let allProductsId = JSON.parse(localStorage.getItem("productsid"));
        if(allProductsId && allProductsId.length){
            let allProducts = [];
            allProductsId.forEach(c=>{
                let p = localStorage.getItem(c);
                if(p && p.id){
                    allProducts.push(p);
                }
            });
            state.products = allProducts;
        } 
    }
}

